import { FeatureFlags } from '@janeapp/feature-flags-client/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from '~/queries';
import App from './App.tsx';
import { setupStore } from './state/store.ts';
import { configureDatadogRum, configureSentry } from './utilities';

configureSentry();
configureDatadogRum();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <FeatureFlags.Provider>
    <QueryClientProvider client={queryClient}>
      <Provider store={setupStore()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
    </QueryClientProvider>
  </FeatureFlags.Provider>
);
